import { FILE_SCAN_LABELS, type FileInfo } from '@epc/contracts';
import clsx from 'clsx';

/**
 * Ссылка на файл с учётом антивируса (DEV-10): файл на проверке или в карантине показывается без ссылки,
 * с пояснением, — иначе человек получил бы отказ сервера вместо файла.
 */
export function FileLink({
  file,
  className,
}: {
  file: { id: string; name: string; scanState?: FileInfo['scanState'] };
  className?: string;
}) {
  const blocked = file.scanState === 'pending' || file.scanState === 'infected' || file.scanState === 'error';
  if (blocked)
    return (
      <span className={clsx('[overflow-wrap:anywhere] text-ink-2', className)}>
        {file.name}{' '}
        <span className={file.scanState === 'infected' ? 'text-danger' : undefined}>
          ({FILE_SCAN_LABELS[file.scanState!].toLowerCase()})
        </span>
      </span>
    );
  return (
    <a
      href={`/api/v1/files/${file.id}/download`}
      className={clsx('text-accent-text [overflow-wrap:anywhere] hover:underline', className)}
    >
      {file.name}
    </a>
  );
}
